// extracted by mini-css-extract-plugin
module.exports = {"container":"aboutStyles_container__29Ad-","about_wrapper":"aboutStyles_about_wrapper__3L_WJ"};